export default "__VITE_ASSET__2e6d1c8f__"